import { observable, action, makeObservable } from 'mobx';

export class LoaderModel {
    @observable
    public isOpen: boolean;

    @observable
    public requestCount: number;

    @observable
    public text?: string;

    constructor(isOpen: boolean = false, requestCount: number = 0) {
        this.isOpen = isOpen;
        this.requestCount = requestCount;

        makeObservable(this);
    }

    @action
    show(text?: string) {
        this.isOpen = true;
        this.requestCount++;

        if (text !== undefined) {
            this.text = text;
        }
    }

    @action
    hide() {
        this.requestCount--;

        if (this.requestCount === 0) {
            this.isOpen = false;
            this.text = undefined;
        }
    }
}

export default LoaderModel;
